import { classNames } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import { fmt } from "discourse/lib/computed";
import discourseComputed from "discourse/lib/decorators";
import { i18n } from "discourse-i18n";
import DropdownSelectBoxHeaderComponent from "select-kit/components/dropdown-select-box/dropdown-select-box-header";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const NotificationsFilterHeader = dt7948.c(class NotificationsFilterHeader extends DropdownSelectBoxHeaderComponent {
  static {
    dt7948.g(this.prototype, "label", [fmt("value", "user.user_notifications.filters.%@")]);
  }
  #label = (dt7948.i(this, "label"), void 0);
  caretIcon(isExpanded) {
    return isExpanded ? "caret-up" : "caret-down";
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [discourseComputed("selectKit.isExpanded")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div class=\"select-kit-header-wrapper\">\n      <span class=\"filter-text\">\n        {{i18n \"user.user_notifications.filters.filter_by\"}}\n      </span>\n      <span class=\"header-text\">\n        {{i18n this.label}}\n      </span>\n      {{icon this.caretIcon class=\"caret-icon\"}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        i18n,
        icon
      })
    }), this);
  }
}, [classNames("notifications-filter-header", "btn-flat")]);
export default NotificationsFilterHeader;